import api from './client';

export const login = (credentials) => api.post('/auth/login', credentials);
export const changePassword = (data) => api.put('/auth/password', data);

const REFRESH_AFTER_S = 12 * 3600;

function tokenAgeSeconds(token) {
  try {
    const { iat } = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return Date.now() / 1000 - iat;
  } catch {
    return Infinity;
  }
}

// Renews the 7-day token when it's older than 12h. If it has already expired the
// request 401s and the client interceptor logs the user out.
export async function refreshTokenIfStale(force = false) {
  const token = localStorage.getItem('kspro_token');
  if (!token || (!force && tokenAgeSeconds(token) < REFRESH_AFTER_S)) return;
  const res = await api.post('/auth/refresh');
  localStorage.setItem('kspro_token', res.data.token);
}
